<section class="h-100 position-relative">
    <sen-app-set-margin></sen-app-set-margin>
    <mat-tab-group animationDuration="0ms" class="px-3 sen-submenu-color">
        <mat-tab label="General">
            <ng-template matTabContent>
                <sen-app-general></sen-app-general>
            </ng-template>
        </mat-tab>
        <mat-tab label="Extra Services">
            <ng-template matTabContent>
                <sen-app-extra-services></sen-app-extra-services>
            </ng-template>
        </mat-tab>
        <mat-tab label="Offer Text">
            <ng-template matTabContent>
                <sen-app-offer-text></sen-app-offer-text>
            </ng-template>
        </mat-tab>
        <mat-tab label="Final Text">
            <ng-template matTabContent>
                <sen-app-final-text></sen-app-final-text>
            </ng-template>
        </mat-tab>
    </mat-tab-group>
    <button mat-raised-button color="primary" class="mr-3 mb-2 py-1 sen-bottom-button">
        <mat-icon>picture_as_pdf</mat-icon>{{translate.getLng('PDF_PRINT')}}
    </button>
</section>